/* unplugin-vue-components disabled */import { render } from "./obtainingCustomers.vue?vue&type=template&id=b954d1ac"
import script from "./obtainingCustomers.vue?vue&type=script&lang=js"
export * from "./obtainingCustomers.vue?vue&type=script&lang=js"

import "./obtainingCustomers.vue?vue&type=style&index=0&id=b954d1ac&lang=css"

import exportComponent from "E:\\work\\wwwroot\\new-landing-page-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__